var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"b--greyhound ba bg-transparent outline-0 pointer ph4 ph5-xl pv3 warm-black",on:{"click":function($event){_vm.$emit('button-activated', _vm.id)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }